import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[appDragFile]'
})
export class DragFileDirective {

  @Output() dragOver: EventEmitter<Event> = new EventEmitter();
  @Output() dragEnter: EventEmitter<Event> = new EventEmitter();
  @Output() dragLeave: EventEmitter<Event> = new EventEmitter();
  @Output() fileDrop: EventEmitter<Event> = new EventEmitter();

  constructor() { }

  @HostListener('dragover', ['$event']) onDragOver(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.dragOver.emit(evt);
  }

  @HostListener('dragenter', ['$event']) onDragEnter(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.dragEnter.emit(evt);
  }

  @HostListener('dragleave', ['$event']) onDragLeave(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.dragLeave.emit(evt);
  }

  @HostListener('drop', ['$event']) onFileDrop(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.fileDrop.emit(evt);
  }

}
